import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { LocalStorageService } from "ng2-webstorage";



@Component({
  selector: 'selectdashboardH',
  templateUrl: 'selectdashboardH.component.html',
  styleUrls: ['selectdashboardH.component.scss'],

})
export class SelectdashboardHComponent implements OnInit {
  constructor(private router: Router, private localStorage: LocalStorageService) { }


  display = "none";
  public parent_email: string = "";


  ngOnInit() {
    // this.getSubjects();
    this.parent_email = 'admin@abc.com';
      console.log("parent_email", this.parent_email);


  }

  onButtonClick1() {
    this.router.navigate(['parent/add-academic-year']);
  }
  onButtonClick2() {
    this.router.navigate(['parent/add-level']);
  }
  onButtonClick3() {
    this.router.navigate(['parent/add-semester']);
  }
  onButtonClick4() {
    this.router.navigate(['parent/add-grade-to-level']);
  }
  onButtonClick5() {
    this.router.navigate(['parent/subject']);
  }
  onButtonClick6() {
    this.router.navigate(['parent/sub-subject']);
  }
  onButtonClick7() {
    this.router.navigate(['parent/add-exam']);
  }
  onButtonClick8() {
    this.router.navigate(['parent/view-course']);
  }
  onButtonClick9() {
    this.router.navigate(['parent/semester']);
  }
  onButtonClick10() {
    this.router.navigate(['parent/add-subject']);
  }
  onButtonClick11() {
    this.router.navigate(['parent/add-submodule']);
  }
  onButtonClick12() {
    this.router.navigate(['parent/add-teacher-sub']);
  }
  onButtonClick13() {
    this.router.navigate(['parent/add-batch']);
  }
  onButtonClick14() {
    this.router.navigate(['parent/subject-teacher']);
  }
  onButtonClick15() {
    this.router.navigate(['parent/Bulk-upload-s']);
  }

  onButtonClick16() {
    this.router.navigate(['parent/manage-drc-settings']);
  }

  onButtonClick17() {
    this.router.navigate(['parent/parent-drc-access']);
  }

  onButtonClick18() {
    this.router.navigate(['parent/Bulk-upload']);
  }

  onButtonClick19() {
    this.router.navigate(['parent/freeze-drc-grades']);
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Selectdashboard/selectdashboardH.ts